import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsComponent } from 'src/app/components/analytics/analytics.component';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';

@Component({
  selector: 'app-distributor-analytics-detail',
  standalone: true,
  imports: [SharedModule, AnalyticsComponent],
  templateUrl: './distributor-analytics-detail.component.html',
  styleUrl: './distributor-analytics-detail.component.scss'
})
export class DistributorAnalyticsDetailComponent {
  distributorId: string;
  distributorEmail: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    // Get data from the URL path
    this.route.params.subscribe(params => {
      this.distributorId = params['distributorId'];
    });

    // Get email from navigation state
    const navigation = this.router.getCurrentNavigation();
    this.distributorEmail = navigation?.extras?.state?.['email'] ?? this.distributorId
  }

  backToHome() {
    this.router.navigate(['/home']);
  }

}
